// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","logo":"Header_logo__3T0lc"};